import './detailsDataKeyValueComponent.scss'
import React from 'react';
import TooltipComponent from "../tooltip/tooltipComponent";

interface DetailsDataKeyValueComponentProps {
    title: string;
    isHorizontal?: boolean;
    maxLength?: number;
    fullWidth?: boolean;
}

const DetailsDataKeyValueComponent = (props: React.PropsWithChildren<DetailsDataKeyValueComponentProps>) => {
    const {title, children, isHorizontal, fullWidth} = props;
    let {maxLength} = props;
    if (!maxLength) maxLength = 42;
    const isFullWidth = fullWidth ? "full-width" : "";

    return (
        <div
            className={isHorizontal ? "d-flex align-items-center data-title-value-wrapper" : "data-title-value-wrapper"}>
            <div className="data-title">{title}</div>
            {children && children?.toString().length > maxLength ?
                <TooltipComponent
                    placement={'top'}
                    tooltip={children}
                    arrow={true}>
                    <div
                        className={isHorizontal ? `pdd-left-5 data-value ${isFullWidth}` : `data-value ${isFullWidth}`}>{children}</div>
                </TooltipComponent> :
                <div
                    className={isHorizontal ? `pdd-left-5 data-value ${isFullWidth}` : `data-value ${isFullWidth}`}>{children}</div>
            }
        </div>
    )
}
export default DetailsDataKeyValueComponent;
